import { render, staticRenderFns } from "./WeChatInfoCell.vue?vue&type=template&id=42d83b5d"
import script from "./WeChatInfoCell.vue?vue&type=script&lang=js"
export * from "./WeChatInfoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports